import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { DateRangePicker } from "react-dates";
import Button from "../../components/common/button";
import RadioButton from "../../components/common/radioButton";
import RupeeIcon from "../../images/rupee.svg";
import downloadIcon from "../../images/download.svg";
import * as actions from "./actions";
import "./styles.css";
import CumulativePayout from "../../components/cumulativePayout";
import { opdbGTM } from "../../utils/pulseUtils";
import backArrowWithTail from "../../images/backArrowWithTail.svg";
import chooseDate from "../../images/chooseDate.svg";
import FileDownload from "js-file-download";

const downloadReportButtonStyle = {
  width: "100%",
  padding: "0px 12px",
};

const downlaodCsvButtonStyle = {
  width: "344px",
  padding: "0px 12px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
};
class PayoutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      period: "Daily",
      startDate: null,
      endDate: null,
      startDateForDownloadReport: null,
      endDateForDownloadReport: null,
      focusedInput: null,
      disableNext: false,
      pageNum: 1,
      showCumulativeTable: false,
      isDownloadReportPageActive: false,
    };
  }

  componentDidMount() {
    this.callPayout();
    opdbGTM.tabClicked("od_payout_tab_clicked");
  }

  componentWillUnmount() {
    this.props.clearPayoutData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.payoutList.length &&
      this.props.payoutList !== prevProps.payoutList
    ) {
      this.props.calculateCumulates(this.props.payoutList);
    }
  }

  onPeriodChange = (value) => this.setState({ period: value });

  onStartDateChange = (value) => this.setState({ startDate: value });

  onEndDateChange = (value) => this.setState({ endDate: value });

  onDateRangeChange = ({ startDate, endDate }) => {
    if (this.state.isDownloadReportPageActive) {
      this.setState({
        startDateForDownloadReport: startDate,
        endDateForDownloadReport: endDate,
      });
    } else {
      this.setState({ startDate, endDate });
    }
  };

  onDateRangeFocus = (focusedInput) => this.setState({ focusedInput });

  rangeChecker = (day) => moment().diff(day) < 0;

  callPayout = () => {
    let query = {
      settled_after: new moment().subtract(7, "days").format("YYYY-MM-DD"),
      settled_before: new moment().format("YYYY-MM-DD"),
      offset: 0,
      limit: 25,
    };
    this.props.getPayoutList(query);
    document.title = "Payout";
  };

  isDatesOutOfRange = () => {
    const {
      endDate,
      startDate,
      endDateForDownloadReport,
      startDateForDownloadReport,
      isDownloadReportPageActive,
    } = this.state;
    if (isDownloadReportPageActive) {
      return (
        endDateForDownloadReport.diff(startDateForDownloadReport, "days") > 30
      );
    }
    return endDate.diff(startDate, "days") > 30;
  };

  onSearchClick = () => {
    const { endDate, startDate } = this.state;
    if (!startDate || !endDate) {
      alert("Kindly select the date range");
      return;
    }
    let query = {
      settled_after: new moment(startDate).format("YYYY-MM-DD"),
      settled_before: new moment(endDate).format("YYYY-MM-DD"),
      offset: 0,
      limit: endDate.diff(startDate, "days") > 7 ? 40 : 25,
    };
    if (!this.isDatesOutOfRange()) {
      this.props.getPayoutList(query);
      this.setState({ disableNext: false, pageNum: 1 });
      if (startDate && endDate) {
        this.setState({ showCumulativeTable: true });
      }
      opdbGTM.payoutSearchClicked(query.settled_after, query.settled_before);
    } else {
      alert("Kindly select the date range of 30 days");
      this.setState({ startDate: null, endDate: null });
    }
    return;
  };

  onSearchClickForDownloadReport = () => {
    const { endDateForDownloadReport, startDateForDownloadReport } = this.state;
    console.log(
      "onSearchClickForDownloadReport",
      startDateForDownloadReport,
      endDateForDownloadReport
    );

    if (!startDateForDownloadReport || !endDateForDownloadReport) {
      alert("Kindly select the date range");
      return;
    }

    let query = {
      journey_start_date: new moment(startDateForDownloadReport).format(
        "YYYY-MM-DD"
      ),
      journey_end_date: new moment(endDateForDownloadReport).format(
        "YYYY-MM-DD"
      ),
    };
    if (!this.isDatesOutOfRange()) {
      this.props.getPaytmAssuredClaimReport(query);
    } else {
      alert("Kindly select the date range of 30 days");
      this.setState({
        startDateForDownloadReport: null,
        endDateForDownloadReport: null,
      });
    }
    return;
  };

  onClearClick = () => {
    if (this.state.isDownloadReportPageActive) {
      this.props.clearPaytmAssuredClaimReport();
      this.setState({
        startDateForDownloadReport: null,
        endDateForDownloadReport: null,
      });
    } else {
      this.callPayout();
      this.setState({ startDate: null, endDate: null });
      this.setState({ showCumulativeTable: false });
    }
  };

  amountFormatting(value) {
    if (!value) return "0.0";
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }

  onDownloadIconClick = (bookingDate) => {
    opdbGTM.payoutDownloadClicked();
    this.props.downloadReport(bookingDate);
  };

  onDownloadPdfClick = (date) => {
    this.props.downloadPDF(date);
  };

  toggleDownloadReportPage = () => {
    this.setState({
      isDownloadReportPageActive: !this.state.isDownloadReportPageActive,
    });
    this.onClearClick();
  };

  handleDownloadCsvClicked = async () => {
    const { startDateForDownloadReport, endDateForDownloadReport } = this.state;
    const { paytmAssuredClaimReport = {} } = this.props;
    const { csvData = "" } = paytmAssuredClaimReport;
    const fileName = `${startDateForDownloadReport.format(
      "DD-MM-YYYY"
    )}_to_${endDateForDownloadReport.format(
      "DD-MM-YYYY"
    )}_PaytmAssuredClaimReport.csv`;
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    FileDownload(csvBlob, fileName);
  };

  render() {
    let startIndex = (this.state.pageNum - 1) * 25;
    let endIndex = this.state.pageNum * 25;
    const {
      startDate,
      endDate,
      showCumulativeTable,
      isDownloadReportPageActive,
      startDateForDownloadReport,
      endDateForDownloadReport,
    } = this.state;
    const { cumulativeData, payoutList, paytmAssuredClaimReport } = this.props;
    const settled_after = new moment(startDate).format("YYYY-MM-DD");
    const settled_before = new moment(endDate).format("YYYY-MM-DD");
    console.log("isDownloadReportPageActive", this.props);
    return (
      <div className="payout">
        {isDownloadReportPageActive ? (
          <div className="download-report-header">
            <div className="backButtonContainer">
              <img
                alt="back-button"
                src={backArrowWithTail}
                onClick={this.toggleDownloadReportPage}
                className="pointer"
              />
              <div className="boldText">Paytm Assured Claim Report</div>
            </div>
            <div className="download-report-date-picker-container">
              <div className="choose-date-subtext">
                Please select journey date
              </div>
              <div className="dateRangeButtonsContainer">
                <DateRangePicker
                  startDateId="start_date"
                  endDateId="end_date"
                  daySize={30}
                  displayFormat="DD-MM-YYYY"
                  isOutsideRange={this.rangeChecker}
                  hideKeyboardShortcutsPanel={true}
                  startDate={startDateForDownloadReport}
                  endDate={endDateForDownloadReport}
                  focusedInput={this.state.focusedInput}
                  onDatesChange={this.onDateRangeChange}
                  onFocusChange={this.onDateRangeFocus}
                />
                <div>
                  <Button
                    styleObj={downloadReportButtonStyle}
                    label="Search"
                    onButtonClick={this.onSearchClickForDownloadReport}
                  />
                </div>
                {(startDateForDownloadReport || endDateForDownloadReport) && (
                  <div>
                    <Button
                      styleObj={downloadReportButtonStyle}
                      label="Clear"
                      onButtonClick={this.onClearClick}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="download-report-content">
              {paytmAssuredClaimReport.isSearched ? (
                paytmAssuredClaimReport.csvData ? (
                  <div className="download-report-available-container">
                    <div className="download-report-content-text">
                      Paytm Assured Report has been generated
                    </div>
                    <Button
                      label="Download CSV"
                      styleObj={downlaodCsvButtonStyle}
                      icon={downloadIcon}
                      onButtonClick={this.handleDownloadCsvClicked}
                    />
                  </div>
                ) : (
                  <div className="download-report-available-container">
                    <div className="download-report-content-text">
                      Something went wrong
                    </div>
                  </div>
                )
              ) : (
                <div className="download-report-content-img-container">
                  <img
                    src={chooseDate}
                    alt="choose-date"
                    height={300}
                    width={300}
                  />
                  <div className="download-report-content-text">
                    Please select Journey Date to download the report
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className="row payout-header">
              <div className="col-xs-2">
                <span className="payout-header-text">Payouts</span>
                <br />
                <span
                  className="payout-updated-date hide"
                  style={{ display: "none" }}
                >
                  Last Updates
                </span>
              </div>
              <div className="col-xs-2 hide">
                <div className="radio-container">
                  <RadioButton
                    label="Daily"
                    isChecked={this.state.period === "Daily"}
                    onSelectionChange={this.onPeriodChange}
                  />
                  <RadioButton
                    label="Weekly"
                    isChecked={this.state.period === "Weekly"}
                    onSelectionChange={this.onPeriodChange}
                  />
                  <RadioButton
                    label="Monthly"
                    isChecked={this.state.period === "Monthly"}
                    onSelectionChange={this.onPeriodChange}
                  />
                </div>
              </div>
              <div className="col-xs-1 center hide">{/*icon={Download}*/}</div>
            </div>
            <div className="buttonsContainer">
              <div className="dateRangeButtonsContainer">
                <DateRangePicker
                  startDateId="start_date"
                  endDateId="end_date"
                  daySize={30}
                  displayFormat="DD-MM-YYYY"
                  isOutsideRange={this.rangeChecker}
                  hideKeyboardShortcutsPanel={true}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  focusedInput={this.state.focusedInput}
                  onDatesChange={this.onDateRangeChange}
                  onFocusChange={this.onDateRangeFocus}
                />
                <div>
                  <Button
                    styleObj={downloadReportButtonStyle}
                    label="Search Payouts"
                    onButtonClick={this.onSearchClick}
                  />
                </div>
                {showCumulativeTable && (
                  <div>
                    <Button
                      styleObj={downloadReportButtonStyle}
                      label="Clear"
                      onButtonClick={this.onClearClick}
                    />
                  </div>
                )}
              </div>
              <div className="textButtonContainer">
                <div className="boldText">Paytm Assured Claim Report</div>
                <div>
                  <Button
                    styleObj={downloadReportButtonStyle}
                    label="Download Report"
                    onButtonClick={this.toggleDownloadReportPage}
                  />
                </div>
              </div>
            </div>
            <div className="payout-content">
              {showCumulativeTable && (
                <CumulativePayout
                  cumulativeData={cumulativeData}
                  startDate={settled_after}
                  endDate={settled_before}
                  amountFormatting={this.amountFormatting}
                  payoutList={payoutList}
                />
              )}
              <div className="table-heading">Daily Report</div>

              <table className="app-table">
                <thead>
                  <tr className="payout-table-header">
                    <th>No</th>
                    <th>Payment Date</th>
                    <th>Settlement Date</th>
                    <th>Booked Seats</th>
                    <th>Amount</th>
                    <th>Commission</th>
                    <th>Cancelled Seats</th>
                    <th>Cancelled Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!payoutList.length && (
                    <tr>
                      <td colSpan={9} className="table-no-data">
                        No Data Found
                      </td>
                    </tr>
                  )}
                  {payoutList.slice(startIndex, endIndex).map((el, i) => (
                    <tr key={i} className="payout-table-row">
                      <td>{i + 1}</td>
                      <td>{el.payment_date}</td>
                      <td>{el.booking_date}</td>
                      <td>{el.booked_seats}</td>
                      <td>
                        <img
                          className="rupee-icon"
                          alt="Rupee-Icon"
                          src={RupeeIcon}
                        />{" "}
                        {this.amountFormatting(el.booking_amount)}
                      </td>
                      <td>
                        <img
                          className="rupee-icon"
                          alt="Rupee-Icon"
                          src={RupeeIcon}
                        />{" "}
                        {this.amountFormatting(el.commission)}
                      </td>
                      <td>{el.cancelled_seats}</td>
                      <td>
                        <img
                          className="rupee-icon"
                          alt="Rupee-Icon"
                          src={RupeeIcon}
                        />{" "}
                        {this.amountFormatting(el.cancellation_amount)}
                      </td>
                      <td className="actionsTd">
                        <div
                          className="download-button"
                          onClick={() =>
                            this.onDownloadIconClick(el.booking_date)
                          }
                        >
                          <img src={downloadIcon} alt="download-icon" />
                          <span className="download-text">CSV</span>
                        </div>
                        <div
                          className="download-button"
                          onClick={() =>
                            this.onDownloadPdfClick(el.booking_date)
                          }
                        >
                          <img src={downloadIcon} alt="download-icon" />
                          <span className="download-text">PDF</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  payoutList: store.payoutReducer.payoutList,
  cumulativeData: store.payoutReducer.cumulativeData,
  paytmAssuredClaimReport: store.payoutReducer.paytmAssuredClaimReport,
});

const mapDispatchToProps = (dispatch) => ({
  getPayoutList: (query, isNewQuery) =>
    dispatch(actions.getPayoutList(query, isNewQuery)),
  getPaytmAssuredClaimReport: (query) =>
    dispatch(actions.getPaytmAssuredClaimReport(query)),
  clearPaytmAssuredClaimReport: () =>
    dispatch(actions.clearPaytmAssuredClaimReport()),
  downloadReport: (settledAt) => dispatch(actions.downloadReport(settledAt)),
  downloadPDF: (settledAt) => dispatch(actions.downloadPDF(settledAt)),
  clearPayoutData: () => dispatch(actions.clearPayoutData()),
  calculateCumulates: (data) => dispatch(actions.calculateCumulates(data)),
});

PayoutContainer.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(PayoutContainer);
